import { Logout } from '../../features/logout'
import { PaymentLandingWidget } from '../../widgets/paymentLanding'
import { HOME_ROUTE } from '../../app/router/routes'
import { LayoutPages } from '../layoutPages'
import classes from './home.module.scss'
import { useAppSelector } from '../../app/store/store'
import { MyPayouts } from '../../widgets/myPayouts'
import { FEATURES, hasFeature } from '../../entities/my'


export default function HomePage(){

    const {my} = useAppSelector(s => s.myReducer)
    const showTutorAccruals = my.role === 'tutor' && hasFeature(my, FEATURES.TUTORS.PAYOUTS_READ, my.id)

    return (
        <LayoutPages title={HOME_ROUTE.name}>
            <section className={classes.container}>
                <PaymentLandingWidget />
                {
                    showTutorAccruals &&
                    <section className={classes.dashboard}>
                        <section className={classes.card}>
                            <MyPayouts key={my.id} defaultOpen />
                        </section>
                    </section>
                }
                <Logout />
            </section>
        </LayoutPages>
    )
}
